export default {
	searchParams: {
		partsNo: null,
		useYn: null
	},
	partsInfo: [],
	useYnList: [],
	gridUseYnList: [],
	groups: {
		//페이징처리에 필요한것들
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	},
	selectedRow: {
		partsNo: '',
		partsName: '',
		partsEnName: '',
		partsZnName: '',
		partsSize:'',
		useYn: ''
	},
	// 업체정보 파라미터 값
	compPopupParams: {
		cpnyCd: '',
		cpnyNm: '',
		cpnyScn: ''
	}
};